var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrincipal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "627821DB-A42A-44B7-BE3C-2124E3D57505") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rides---Reservations",
    transform: "translate(-543.000000, -371.000000)",
    stroke: "#A1A5B3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "row-copy",
    transform: "translate(149.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(393.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-icon/principal"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    points: "12 16.6 6.12214748 21.0901699 8.57619654 14.1124612 2.48943484 9.90983006 9.88397309 10.0875388 12 3 14.1160269 10.0875388 21.5105652 9.90983006 15.4238035 14.1124612 17.8778525 21.0901699"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincipal);
export default __webpack_public_path__ + "static/media/principal.b17f18cc7ffcb0269e90f292f234b3e9.svg";
export { ForwardRef as ReactComponent };